import React from 'react';
import styles from './FilterBar.module.css';

// Row of filters above a table. `shown`/`total` render the "x of y" count;
// `onClear` (pass it only while a filter is active) renders "Clear filters".
function FilterBar({ children, shown, total, onClear }) {
  return (
    <div className={styles.bar}>
      {children}
      {(total !== undefined || onClear) && (
        <div className={styles.meta}>
          {total !== undefined && <span>Showing {shown} of {total}</span>}
          {onClear && <button type="button" className={styles.clear} onClick={onClear}>Clear filters</button>}
        </div>
      )}
    </div>
  );
}

// options: [{ value, label }] or plain strings. The empty value means "all".
function FilterSelect({ label, value, onChange, options, allLabel = 'All' }) {
  return (
    <label className={styles.field}>
      <span className={styles.label}>{label}</span>
      <select className={styles.control} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{allLabel}</option>
        {options.map((option) => {
          const item = typeof option === 'string' ? { value: option, label: option } : option;
          return <option key={item.value} value={item.value}>{item.label}</option>;
        })}
      </select>
    </label>
  );
}

function FilterSearch({ label = 'Search', value, onChange, placeholder }) {
  return (
    <label className={styles.search}>
      <span className={styles.label}>{label}</span>
      <input type="search" className={styles.control} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
    </label>
  );
}

export { FilterBar, FilterSelect, FilterSearch };
